/** IME に消費された keydown の keyCode。 */
const IME_PROCESSED_KEY_CODE = 229;

/**
 * この keydown が IME(かな漢字変換)に消費されたものかどうか。
 *
 * 変換確定の Enter を「送信」と誤認しないために使う。
 * compositionend と keydown の発火順はブラウザによって異なる:
 *
 * - Chrome/Firefox: keydown(isComposing=true) → compositionend
 * - Safari:         compositionend → keydown(isComposing=false)
 *
 * Safari は確定 Enter の時点で既に合成終了扱いなので isComposing だけでは弾けない。
 * ただし IME が消費したキーには keyCode 229 が入るため、これを併せて見れば
 * 発火順やタイミングに依存せず確定 Enter を判別できる。
 *
 * Safari 26.5 実測 (ライブ変換 ON、「こんにちは。」を確定):
 *   compositionend → (5ms) → keydown key="Enter" keyCode=229 isComposing=false
 * compositionend と keydown は別マクロタスクで発火するため、合成状態フラグを
 * setTimeout(0) で遅延解除する方式では確定 keydown より先に解除されてしまう。
 */
export function isImeConsumedKeyDown(
	event: Pick<KeyboardEvent, "isComposing" | "keyCode">,
): boolean {
	return event.isComposing || event.keyCode === IME_PROCESSED_KEY_CODE;
}
